import React from "react";

function Payment() {
  return (
    <div>
      <section class="text-gray-500 bg-gray-900 body-font">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 md:mb-0 mb-10">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="./img/qr.jpg"
            />
          </div>
          <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
              Our UPI Service
              <br class="hidden lg:inline-block" />
            </h1>
          </div>
        </div>
        <div role="alert">
          <div class="bg-red-500 text-white font-bold rounded-t px-4 py-2">
            WARNING!
          </div>
          <div class="border border-t-0 border-red-400 rounded-b bg-red-100 px-3 py-2 text-red-700">
            <p>
              Please first verify that it is Manik Paul's Store or not. Do not
              enter stores beside us. For any fraudulent behaviour we are not
              held responsible. You can also verify it by matching our owners
              photo.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Payment;
